var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "follow-modal"
  }, [_c('div', {
    staticClass: "follow-modal-backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "follow-modal-dialog"
  }, [_c('lazy-image', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.anchorPortrait
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "introduction"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.dialogFollowModal')))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "accept-button",
    on: {
      "click": _vm.acceptHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.dialogFollowModalAccept')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel-button",
    on: {
      "click": _vm.cancelHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.dialogFollowModalCancel')))])]), _vm._v(" "), _c('button', {
    staticClass: "xclose-button",
    on: {
      "click": _vm.cancelHandler
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };